import { render, staticRenderFns } from "./CardDetailEdit.vue?vue&type=template&id=e5052a10&scoped=true&"
import script from "./CardDetailEdit.vue?vue&type=script&lang=js&"
export * from "./CardDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailEdit.vue?vue&type=style&index=0&id=e5052a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5052a10",
  null
  
)

export default component.exports